import { render, staticRenderFns } from "./AddProjectModal.vue?vue&type=template&id=27754732&scoped=true"
import script from "./AddProjectModal.vue?vue&type=script&lang=js"
export * from "./AddProjectModal.vue?vue&type=script&lang=js"
import style0 from "./AddProjectModal.vue?vue&type=style&index=0&id=27754732&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27754732",
  null
  
)

export default component.exports